import { audioQuery } from '@/queries/AudioQuery';
import gql from 'graphql-tag';
import { paginationQuery } from '@/queries/PaginationQuery';

export const audioSectionQuery = gql`
  query getAllAudio(
    $filter: String,
    $limit: Int,
    $paged: Int,
    $tag: String,
    $subType: String,
    $subTypeValue: String,
    $type: String
  ) {
    allAudio(
      first: $limit,
      where: { orderby: { field: DATE, order: DESC }, paged: $paged, tag: $tag }
    ) {
      ${audioQuery}
    }
    ${paginationQuery}
  }
`;
